import { Col, Row } from "react-bootstrap";
import "styles/page.css";
import "./ClientCharter.css";
import { PrimaryButton } from "components/buttons";
import { handleOpenPdf } from "utils";
import { ASSETS_BASE_URL } from "constants";
function TreatCustomerFairlyCharter() {
  return (
    <div className="container page">
      <h1 className="page-title">Treat Customers Fairly Charter</h1>

      <p className="page-subtitle">
        The Chairman, the Board and senior management are committed to
        delivering good financial consumer outcomes to our customers. We believe
        in building long-term and mutually beneficial relationships with our
        customers. This Charter specifies our commitment to providing the
        highest standards of fairness in all our dealings with our customers.
      </p>
      <p className="page-subtitle">
        To protect the interests and financial well-being of our customers:
      </p>

      <div className="benefit-card-section">
        <Row>
          <Col xs={12}>
            <div className="benefit-card">
              <h1>
                <span>We commit to embedding fair dealing</span> into our
                institution's corporate culture and core values.
              </h1>
              <ol type="i">
                <li>
                  We will set minimum standards on fair business practices in
                  all dealings with our customers. This includes providing
                  financial services or products suitable to our customers'
                  financial circumstances and preserving the{" "}
                  <b>confidentiality of our customers' information.</b>
                </li>
                <li>
                  We will train all staff attending to customers to{" "}
                  <b>provide quality advice and recommendations;</b> and
                </li>
                <li>
                  We will take customers' feedback seriously and{" "}
                  <b>provide immediate constructive feedback to our staff.</b>
                </li>
              </ol>
            </div>
          </Col>

          <Col xs={12}>
            <div className="benefit-card">
              <h1>
                <span>We commit to ensuring that customers</span> are provided
                with fair terms.
              </h1>
              <ol type="i">
                <li>
                  We will ensure that the terms in our contracts or agreements
                  are{" "}
                  <b>fair, transparent, and well communicated to customers.</b>
                </li>
                <li>
                  We will ensure that terms and conditions set out the
                  respective rights, liabilities, and{" "}
                  <b>
                    obligations clearly and as far as possible in plain
                    language;
                  </b>{" "}
                  and
                </li>
                <li>
                  We will ensure that the terms and conditions in contracts or
                  agreements are{" "}
                  <b>not altered without prior notification to customers.</b>
                </li>
              </ol>
            </div>
          </Col>

          <Col xs={12}>
            <div className="benefit-card">
              <h1>
                <span>
                  We commit to ensuring that customers are provided with clear,
                  relevant and timely information
                </span>{" "}
                on financial services and products.
              </h1>
              <ol type="i">
                <li>
                  We will provide customers with relevant and timely information{" "}
                  <b>in a product disclosure sheet.</b>
                </li>
                <li>
                  We will disclose key product features, fees and charges, and
                  risks and benefits <b>in a clear and concise manner;</b> and
                </li>
                <li>
                  We will ensure critical terms are brought{" "}
                  <b>to customers' attention and explained to them.</b>
                </li>
              </ol>
            </div>
          </Col>

          <Col xs={12}>
            <div className="benefit-card">
              <h1>
                <span>
                  We commit to ensuring that our staff, representatives, and
                  agents exercise due care, skill, and diligence
                </span>{" "}
                when dealing with customers.
              </h1>
              <ol type="i">
                <li>
                  We will conduct sales, advertising, and marketing of our
                  financial services and products{" "}
                  <b>
                    {" "}
                    with integrity and will not make false or exaggerated
                    claims.
                  </b>
                </li>
                <li>
                  We will avoid or clearly disclose{" "}
                  <b>actual or potential conflicts of interest;</b> and
                </li>
                <li>
                  We will ensure staff remuneration takes into consideration
                  whether key performance indicators{" "}
                  <b>
                    relating to the fair treatment of customers have been
                    achieved.
                  </b>
                </li>
              </ol>
            </div>
          </Col>
          <Col xs={12}>
            <div className="benefit-card">
              <h1>
                <span>
                  We commit to ensuring that customers receive suitable advice
                  and recommendations that
                </span>{" "}
                take into account their financial needs and circumstances.
              </h1>
              <ol type="i">
                <li>
                  We will provide clear, relevant, and quality advice or
                  recommendations based on adequate consideration of customers'
                  financial objectives, needs, circumstances, financial
                  situation, and risk appetite{" "}
                  <b>so that customers can make informed decisions.</b>
                </li>
                <li>
                  We will ensure advice or recommendations are substantiated{" "}
                  <b>
                    with a reasonable basis and in the best interest of
                    customers;{" "}
                  </b>
                  and
                </li>
                <li>
                  We will ensure that our customers' data and privacy{" "}
                  <b>are safeguarded.</b>
                </li>
              </ol>
            </div>
          </Col>
          <Col xs={12}>
            <div className="benefit-card">
              <h1>
                <span>
                  We commit to ensuring that customers' complaints and claims
                </span>{" "}
                are handled in a prompt, fair, and effective manner
              </h1>
              <ol type="i">
                <li>
                  We will have in place a proper and well-documented complaints
                  handling process and provide clear redress options{" "}
                  <b>
                    should customers decide to further escalate their
                    complaints.
                  </b>
                </li>
                <li>
                  We will ensure that our staff, representatives, and agents are
                  properly trained to handle and{" "}
                  <b>resolve complaints in an effective and timely manner;</b>{" "}
                  and
                </li>
                <li>
                  We will monitor and evaluate the nature and trend of
                  complaints received through effective root cause analysis and
                  thereafter{" "}
                  <b>
                    take adequate measures to rectify weaknesses identified.
                  </b>
                </li>
              </ol>
            </div>
          </Col>
          <Col xs={12}>
            <div className="benefit-card">
              <h1>
                <span>
                  We commit to ensuring that vulnerable consumers are treated
                  fairly and equitably,
                </span>{" "}
                including by our staff, representatives, and agents
              </h1>
              <ol type="i">
                <li>
                  We will ensure that we assess the needs of vulnerable
                  consumers in our customer base and target market and{" "}
                  <b>implement appropriate policies to meet these needs</b>
                </li>
                <li>
                  We will ensure that our staff, representatives, and agents are
                  well trained to recognize, assess, and respond appropriately{" "}
                  <b>to the needs of vulnerable customers;</b> and
                </li>
                <li>
                  We will have in place sufficient monitoring and evaluation
                  mechanisms to ensure that our staff, representatives, and
                  agents respond to the needs of vulnerable customers and make
                  necessary improvements to{" "}
                  <b>
                    ensure vulnerable consumers continue to receive fair and
                    equitable treatment.
                  </b>
                </li>
              </ol>
            </div>
          </Col>
        </Row>
      </div>
      <div className="d-flex justify-content-center">
        <PrimaryButton
          text="Treat Customers Fairly Charter"
          onClick={() =>
            handleOpenPdf(
              `${ASSETS_BASE_URL}assets/pdf/treat-customer-fairly-charter/Treat Customer Fairly Charter - English & Malay Version (Revised).pdf`
            )
          }
        />
      </div>
    </div>
  );
}

export default TreatCustomerFairlyCharter;
